import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { show_success, remove_flash, dataTruncate } from "lib/helpers"
import { initRemoveItemsHandler, checkboxesGroupController } from "lib/chat_bulk_actions"

// chat/rules/index — data-controller="chat--rules--index"
export default class extends Controller {
  static targets = [
    "rulesTable",
    "scoreGroupsTable",
    "addMessageRuleButton",
    "addScoreGroupButton",
    "ruleDialog",
  ]

  static values = {
    rulesPath: String,
    editRulesPath: String,
    scoreGroupsPath: String,
    newMessageRulePath: String,
    newScoreGroupPath: String,
  }

  connect() {
    checkboxesGroupController("rules", "chatRules")
    checkboxesGroupController("score-groups", "chatRules")
    this.#initDataTables()
  }

  disconnect() {
    if (this.ruleTable) {
      this.ruleTable = destroyTurboDataTable(this.ruleTable)
    }
    if (this.scoreTable) {
      this.scoreTable = destroyTurboDataTable(this.scoreTable)
    }
    $(document).off(".chatRules")
    $("#check-all-rules").off(".chatRules")
    $("#check-all-score-groups").off(".chatRules")
  }

  addMessageRule(event) {
    event.preventDefault()
    this.#newResource(this.newMessageRulePathValue, "chat_message_rule")
  }

  addScoreGroup(event) {
    event.preventDefault()
    this.#newResource(this.newScoreGroupPathValue, "chat_message_score_group")
  }

  editMessageRule(event) {
    event.preventDefault()
    const id = event.currentTarget.dataset.ruleId
    this.#editResource(id, "chat_message_rule", this.editRulesPathValue)
  }

  editScoreGroup(event) {
    event.preventDefault()
    const id = event.currentTarget.dataset.ruleId
    this.#editResource(id, "chat_message_score_group", this.scoreGroupsPathValue)
  }

  #newResource(path, ruleType) {
    $.get(path, (data) => {
      $(this.ruleDialogTarget).html(data)
      $("#rule_dialog_modal").modal("show")

      $(".close").on("click", function () {
        $(this).parent().hide()
      })

      this.#initAjax($(`#new_${ruleType}`), this.tableMapping[ruleType])
    })
  }

  #editResource(id, ruleType, path) {
    const link = `${path}/${id}/edit`
    $.get(link, (data) => {
      $(this.ruleDialogTarget).html(data)
      $("#rule_dialog_modal").modal("show")
      this.#initAjax($(`.edit_${ruleType}`), this.tableMapping[ruleType])
    })
  }

  #initAjax(form, table) {
    form.ajaxForm({
      dataType: "json",
      uploadProgress: (_event, _position, _total, percentComplete) => {
        form.find(".bar").width(`${percentComplete}%`)
      },
      beforeSubmit: () => {
        remove_flash()
        this.#waitMessage(form)
      },
      success: (response) => {
        form.find(".bar").width("100%")
        if (response.success) {
          show_success(response.message)
          $("#rule_dialog_modal").modal("hide")
          table.draw(false)
        } else {
          $("#rule_dialog_modal .content").html(response.message)
          $("#rule_dialog_modal .alert").fadeIn()
        }
        this.#endWaitMessage(form)
      },
      error: () => {
        $("#rule_dialog_modal .content").html("An error occurred during request!")
        $("#rule_dialog_modal .alert").fadeIn()
        this.#endWaitMessage(form)
      },
    })
  }

  #waitMessage(form) {
    form.find(":submit").addClass("loading_submit").enable(false).next(".inline-loading").show()
  }

  #endWaitMessage(form) {
    form.find(":submit").removeClass("loading_submit").enable(true).next(".inline-loading").hide()
  }

  #initDataTables() {
    this.ruleTable = createTurboDataTable(this.rulesTableTarget, {
      dom: 'l<"head-toolbar rule-header">rtip<"footer-toolbar rule-footer">',
      pagingType: "full_numbers",
      processing: true,
      serverSide: true,
      stateSave: true,
      scrollX: true,
      ajax: {
        url: this.rulesPathValue,
        data: (d) => { d.data = "rules" },
        type: "POST",
      },
      initComplete: () => {
        this.#bindRulesRowSelection()
        $(this.addMessageRuleButtonTarget).on("click.chatRules", (e) => this.addMessageRule(e))
      },
      footerCallback: () => {
        $("#check-all-rules").attr("checked", false)
      },
      columnDefs: [
        {
          targets: 0,
          width: "35px",
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<input type="checkbox" class="table-checkbox-chat-rules" id="check--rules${cellData}" name="item_ids[]" value="${cellData}"/> <label for="check--rules${cellData}"><label/>`,
            )
          },
        },
        {
          targets: 1,
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<a href="#" data-rule-id="${cellData}" data-action="click->chat--rules--index#editMessageRule">${dataTruncate(cellData, 40)}</a>`,
            )
          },
        },
        {
          targets: 6,
          createdCell: (cell, cellData, rowData) => {
            if (parseInt(rowData[8], 10) > 0) {
              $(cell).html(`<a href='rules/${cellData}/dictionary'>view</a>`)
            } else {
              $(cell).html("")
            }
          },
        },
        { targets: [0, 2, 5, 6], sortable: false },
      ],
    })

    this.scoreTable = createTurboDataTable(this.scoreGroupsTableTarget, {
      dom: 'l<"head-toolbar score-group-header">rtip<"footer-toolbar score-group-footer">',
      pagingType: "full_numbers",
      processing: true,
      serverSide: true,
      stateSave: true,
      scrollX: true,
      ajax: {
        url: this.rulesPathValue,
        data: (d) => { d.data = "score_groups" },
        type: "POST",
      },
      initComplete: () => {
        $(this.addScoreGroupButtonTarget).on("click.chatRules", (e) => this.addScoreGroup(e))
        $("#loading").hide()
      },
      columnDefs: [
        {
          targets: 0,
          width: "35px",
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<input type="checkbox" class="table-checkbox-chat-score-group" id="check--score-group${cellData}" name="item_ids[]" value="${cellData}"/> <label for="check--score-group${cellData}"><label/>`,
            )
          },
        },
        {
          targets: 1,
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<a href="#" data-rule-id="${cellData}" data-action="click->chat--rules--index#editScoreGroup">${dataTruncate(cellData, 40)}</a>`,
            )
          },
        },
        { targets: [0, 4], sortable: false },
      ],
    })

    this.tableMapping = {
      chat_message_rule: this.ruleTable,
      chat_message_score_group: this.scoreTable,
    }

    $(".rule-header").append($(this.addMessageRuleButtonTarget).remove())
    $(".score-group-header").append($(this.addScoreGroupButtonTarget).remove())

    if ($("#reader").val() === "false") {
      $(".rule-footer").html('<br><br><a href="#" class="remove rules-remove">Remove selected</a>')
      $(".score-group-footer").html('<br><br><a href="#" class="remove score-groups-remove">Remove selected</a>')
      initRemoveItemsHandler("rules", this.ruleTable, "chatRules", this.editRulesPathValue + "/remove")
      initRemoveItemsHandler("score-groups", this.scoreTable, "chatRules", this.scoreGroupsPathValue + "/remove")
    }
  }

  #bindRulesRowSelection() {
    $("#check-all-rules").on("change.chatRules", function () {
      const isChecked = $(this).prop("checked")
      $(".table-checkbox-chat-rules").prop("checked", isChecked)
      $(".table-checkbox-chat-rules").closest("tr").toggleClass("selected-row", isChecked)
    })

    $(document).on("change.chatRules", ".table-checkbox-chat-rules", function () {
      const isChecked = $(this).prop("checked")
      $(this).closest("tr").toggleClass("selected-row", isChecked)
      const allChecked = $(".table-checkbox-chat-rules:checked").length === $(".table-checkbox-chat-rules").length
      $("#check-all-rules").prop("checked", allChecked)
    })

    $("#check-all-score-groups").on("change.chatRules", function () {
      const isChecked = $(this).prop("checked")
      $(".table-checkbox-chat-score-group").prop("checked", isChecked)
      $(".table-checkbox-chat-score-group").closest("tr").toggleClass("selected-row", isChecked)
    })

    $(document).on("change.chatRules", ".table-checkbox-chat-score-group", function () {
      const isChecked = $(this).prop("checked")
      $(this).closest("tr").toggleClass("selected-row", isChecked)
      const allChecked =
        $(".table-checkbox-chat-score-group:checked").length === $(".table-checkbox-chat-score-group").length
      $("#check-all-score-groups").prop("checked", allChecked)
    })
  }
}
